<div class="slider-item">
	<slot />
</div>
